/**
 * UI permission-keys for the `AGENCY` route (Agencies screen).
 * Typed mirror of the BE CSV — confirm strings with the BE. (ENT-89 T15.)
 */
export const AgencyAclKeys = {
  /** Access to the /agencies listing + detail subtree. */
  listingRead: 'agencies:listing:read',
  /** Onboard Agency — gates BOTH the launcher button and the /onboarding/agency route. */
  onboard: 'agencies:onboard',
  /** SA-only: link to the /platform/agencies approval queue. Persona-only CSV key. */
  approvalsRead: 'agencies:approvals:read',
} as const;

export type AgencyAclKey = (typeof AgencyAclKeys)[keyof typeof AgencyAclKeys];
